module.exports = __webpack_public_path__ + "img/survey-creator.cfdd02e5.png";